import React, { useState } from "react";
import { FiPlus, FiChevronDown, FiPackage, FiAlertCircle, FiInbox } from "react-icons/fi";
import "../style/ChallanProductsSection.css";

const ChallanProductsSection = ({
  title = "Products",
  subtitle = "Add products and optional SR numbers for this challan.",
  count = 0,
  hasError = false,
  emptyMessage = "No products added yet",
  onAddProduct,
  onInsertProduct,
  addLabel = "Add Product",
  insertLabel = "Insert Product",
  children,
  actions,
  initialAddProduct = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <section className={`prs-card ${hasError ? "prs-card--error" : ""}`}>
      <header className="prs-header" onClick={toggle} role="button" tabIndex={0}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggle()}
      >
        <span className="prs-header-icon">
          <FiPackage size={17} />
        </span>

        <div className="prs-header-text">
          <span className="prs-header-title">
            {title}
            <span className={`prs-count-pill ${hasError ? "prs-count-pill--error" : ""}`}>
              {count} {count === 1 ? "item" : "items"}
            </span>
          </span>
          {isExpanded && <span className="prs-header-subtitle">{subtitle}</span>}
        </div>

        <div className="prs-header-actions" onClick={(e) => e.stopPropagation()}>
          {isExpanded && onInsertProduct && (
            <button type="button" className="prs-btn prs-btn--ghost" onClick={onInsertProduct}>
              {insertLabel}
            </button>
          )}
        </div>

        <FiChevronDown className={`prs-chevron ${isExpanded ? "prs-chevron--open" : ""}`} size={18} />
      </header>

      <div className={`prs-body ${isExpanded ? "prs-body--open" : ""}`}>
        <div className="prs-body-inner">
          {count === 0 ? (
            <div className={`prs-empty ${hasError ? "prs-empty--error" : ""}`}>
              <span className="prs-empty-icon">
                {hasError ? <FiAlertCircle size={22} /> : <FiInbox size={22} />}
              </span>
              <p className="prs-empty-title">
                {hasError ? "At least one product is required" : emptyMessage}
              </p>
              {onAddProduct && (
                <button type="button" className="prs-btn prs-btn--primary prs-empty-btn" onClick={onAddProduct}>
                  <FiPlus size={15} />
                  {addLabel}
                </button>
              )}
            </div>
          ) : (
            <>
              <div className="prs-rows">{children}</div>
            </>
          )}

          <div className="prs-footer">
            {isExpanded && onAddProduct && (
              <div className="prs-add-row">
                <button type="button" className="prs-btn prs-btn--secondary" onClick={onAddProduct}>
                  <FiPlus size={15} />
                  {addLabel}
                </button>
              </div>
            )}
            {actions && <div className="prs-actions">{actions}</div>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChallanProductsSection;